import { createSelector } from '@reduxjs/toolkit';
import { selectIsWindowMode, selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { forWeb } from '@ff-os/shared-utils/asset-urls';
import { createInputBindings } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { createOptionBindings } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { SvgVariableInput } from '@gift-variable-plugins/svg-shared/SvgVariableInput';
import { SvgVariableOptions } from '@gift-variable-plugins/svg-shared/SvgVariableOptions';

const { createInputSelector, createInputUpdater }
    = createInputBindings<SvgVariableInput>();

export const selectAssetUrlById = createInputSelector(i => i.assetUrl);
export const updateAssetUrlByIds = createInputUpdater('assetUrl');

const { createOptionSelector } = createOptionBindings<SvgVariableOptions>();

export const selectIsOptionalById = createOptionSelector(i => i.isOptional);
export const selectOpenByDefaultById = createOptionSelector(o => o.openByDefault);
export const selectCollectionIdById = createOptionSelector(o => o.collectionId);

export const selectThumbnailAssetUrlById = createSelector([
    selectAssetUrlById,
    selectLanguage
], (url, language) => url && forWeb(url, { w: 50, h: 50, language: language }));

export const selectOpenByDefaultOrWhenWindowed = createSelector([
    selectOpenByDefaultById,
    selectIsWindowMode
], (open, isWindowMode) => open || isWindowMode);